package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LogoutW500Rounded: ImageVector
    get() {
        if (_logoutW500Rounded != null) {
            return _logoutW500Rounded!!
        }
        _logoutW500Rounded = Builder(name = "LogoutW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(202.87f, 848.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-554.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(233.54f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                lineTo(202.87f, 202.87f)
                verticalLineToRelative(554.26f)
                horizontalLineToRelative(233.54f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                lineTo(202.87f, 848.13f)
                close()
                moveTo(674.56f, 525.5f)
                lineTo(403.59f, 525.5f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(270.97f)
                lineTo(605.07f, 365.0f)
                quadToRelative(-12.68f, -12.67f, -12.68f, -31.07f)
                quadToRelative(0.0f, -18.39f, 12.68f, -31.82f)
                quadToRelative(12.67f, -13.68f, 31.7f, -14.06f)
                quadToRelative(19.03f, -0.38f, 32.71f, 13.3f)
                lineTo(816.3f, 448.17f)
                quadToRelative(13.44f, 13.68f, 13.44f, 31.83f)
                reflectiveQuadToRelative(-13.44f, 31.83f)
                lineTo(669.48f, 658.65f)
                quadToRelative(-13.44f, 13.68f, -32.21f, 13.3f)
                quadToRelative(-18.77f, -0.38f, -32.2f, -14.06f)
                quadToRelative(-12.68f, -13.43f, -12.3f, -32.21f)
                quadToRelative(0.38f, -18.77f, 13.06f, -31.44f)
                lineToRelative(68.73f, -68.74f)
                close()
            }
        }
        .build()
        return _logoutW500Rounded!!
    }

private var _logoutW500Rounded: ImageVector? = null
